// src/components/pages/Impressum.js
import React, { useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

function Impressum() {
  const { language } = useLanguage();
  
  // Impressum content in both languages
  const impressumContent = {
    en: {
      title: "Legal Notice",
      lastUpdated: "Last Updated: May 2025",
      sections: [
        {
          title: "Information according to § 5 TMG",
          content: `Burkhard Lübbers-Roese
Am Eiskeller 62
21339 Lüneburg
Germany`
        },
        {
          title: "Contact",
          content: "E-Mail: leon.roese@lucent-webdesign.com"
        },
        {
          title: "VAT ID",
          content: "Sales tax identification number according to § 27 a of the Sales Tax Law: 3312708267"
        },
        {
          title: "Responsible for content according to § 55 Abs. 2 RStV",
          content: `Burkhard Lübbers-Roese
Am Eiskeller 62
21339 Lüneburg
Germany`
        },
        {
          title: "Dispute Resolution",
          content: "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr/. Our email address can be found above in the legal notice. We are not willing or obliged to participate in dispute resolution proceedings before a consumer arbitration board."
        }
      ]
    },
    de: {
      title: "Impressum",
      lastUpdated: "Zuletzt aktualisiert: Mai 2025",
      sections: [
        {
          title: "Angaben gemäß § 5 TMG",
          content: `Burkhard Lübbers-Roese
Am Eiskeller 62
21339 Lüneburg
Deutschland`
        },
        {
          title: "Kontakt",
          content: "E-Mail: leon.roese@lucent-webdesign.com"
        },
        {
          title: "Umsatzsteuer-ID",
          content: "Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: 3312708267"
        },
        {
          title: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
          content: `Burkhard Lübbers-Roese
Am Eiskeller 62
21339 Lüneburg
Deutschland`
        },
        {
          title: "Streitschlichtung",
          content: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/. Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."
        }
      ]
    }
  };
  
  const content = language === 'de' ? impressumContent.de : impressumContent.en;

  // Update document title
  useEffect(() => {
    document.title = `${content.title} | Lucent Web Design`;
  }, [content.title]);
  
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="impressum" style={{ padding: '80px 0', color: 'var(--text-light)' }}>
      <div className="container">
        <h1 style={{ marginBottom: '20px', color: 'var(--text-light)' }}>{content.title}</h1>
        <p className="last-updated" style={{ marginBottom: '40px', color: '#858585', fontStyle: 'italic' }}>
          {content.lastUpdated}
        </p>
        
        {/* Impressum Sections */}
        {content.sections.map((section, index) => (
          <div key={index} className="impressum-section" style={{ marginBottom: '40px' }}>
            <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: 'var(--primary)' }}>
              {section.title}
            </h2>
            <p style={{ lineHeight: '1.7', marginBottom: '15px', whiteSpace: 'pre-line' }}>
              {section.content}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Impressum;